import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutGrid,
  MessageCircle,
  Settings,
  LogOut,
  ChevronRight,
  ListMusic,
  BarChart3,
} from "lucide-react";

const navItems = [
  {
    label: "Edições",
    href: "/admin/edicoes",
    icon: LayoutGrid,
  },
  {
    label: "Acessos",
    href: "/admin/acessos",
    icon: BarChart3,
  },
  {
    label: "WhatsApp Marketing",
    href: "/admin/whatsapp-marketing",
    icon: MessageCircle,
  },
  {
    label: "Playlist",
    href: "/admin/playlist",
    icon: ListMusic,
  },
  {
    label: "Configurações",
    href: "/admin/configuracoes",
    icon: Settings,
  },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function Sidebar({ isOpen, onClose }: SidebarProps) {
  const location = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  const handleNavClick = () => {
    // Fecha o sidebar no mobile após clicar
    onClose();
  };

  return (
    <aside 
      className={`
        flex flex-col w-64 min-h-screen bg-black text-white shrink-0
        fixed lg:static top-0 bottom-0 left-0 z-50
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}
    >
      {/* Logo */}
      <div className="px-6 py-6 border-b border-white/10">
        <img
          src="/images/dunada-branco.png"
          alt="DU NADA"
          className="w-30 h-8 object-contain"
        />
        <p className="text-white/30 text-xs mt-0.5">Painel Administrativo</p>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-0.5">
        {navItems.map(({ label, href, icon: Icon }) => {
          const isActive =
            location.pathname === href || 
            location.pathname.startsWith(href + "/") ||
            (href === "/admin/edicoes" && location.pathname === "/admin");
          return (
            <Link
              key={href}
              to={href}
              onClick={handleNavClick}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all group ${
                isActive
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/10"
              }`}
            >
              <Icon
                className={`w-4 h-4 shrink-0 ${
                  isActive ? "text-black" : "text-white/40 group-hover:text-white"
                }`}
              />
              <span className="flex-1">{label}</span>
              {isActive && (
                <ChevronRight className="w-3.5 h-3.5 text-black/40" />
              )}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-3 py-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium text-white/40 hover:text-white hover:bg-white/10 transition-all"
        >
          <LogOut className="w-4 h-4 shrink-0" />
          Sair
        </button>
      </div>
    </aside>
  );
}
